import { CSSProperties, ReactElement, useContext } from "react";
import { IEAFProduction, IProductionExtended } from "../../../../types";
import { InputAdornment, TextField, useMediaQuery } from "@mui/material";
import PieChart from "../../../../components/charts/pieChart";
import { IPieConfig } from "../../../../components/charts/types";
import { formatDateTimeWithSeconds, formatNumber, toTons } from "../../../../system/utils";
import { SystemContext } from "../../../../context/systemContext";
import { getLanguage } from "../../configuration/language";
import { getPalette } from "../../../../configuration/configuration";

interface IGeneralPanelProps {
  productionItem: IProductionExtended;
}


const GeneralPanel = ({ productionItem }: IGeneralPanelProps): ReactElement => {
  const systemContext = useContext(SystemContext);
  const matchSM = useMediaQuery("(min-width:1200px)");
  const heat = productionItem as IEAFProduction;

  const pieConfig: IPieConfig = {
    series: [
      { name: "Power ON", value: parseFloat(formatNumber(heat.powerON, 1)), color: getPalette().statusColor.good.background },
      { name: "Power OFF", value: parseFloat(formatNumber(heat.powerOFF, 1)), color: getPalette().statusColor.error.background }
    ],
    padAngle: 0.05,
    innerRadius: 0.5,
    seriesRadius: 1.1,
    showLegend: true,
    showTotal: true
  };

  const temperature = {
    datetime: 0,
    value: 0
  };

  productionItem.variables.forEach(variable => {
    if (variable.datetime > temperature.datetime) {
      temperature.datetime = variable.datetime;
      temperature.value = variable.value as number;
    }
  });

  const layout: CSSProperties = matchSM
    ? {
      gridTemplateColumns: "1fr 200px"
    }
    : {};

  return(
    <div className="display-grid" style={layout}>
      <div className="display-flex-row flex-wrap" >
        <TextField className="form-control"
          variant="standard"
          size="small"
          slotProps={{ input: { readOnly: true, }}}
          label={"Machine"}
          defaultValue={heat.machine.name}/>

        <TextField className="form-control"
          variant="standard"
          slotProps={{ input: { readOnly: true, }}}
          label={getLanguage(systemContext.languageCode).heatNumber}
          defaultValue={heat.heatNumber}/>

        <TextField className="form-control"
          variant="standard"
          slotProps={{ input: { readOnly: true, }}}
          label={getLanguage(systemContext.languageCode).grade}
          defaultValue={heat.steel.code}/>

        <TextField className="form-control-large"
          variant="standard"
          slotProps={{ input: { readOnly: true, }}}
          label={getLanguage(systemContext.languageCode).begin}
          defaultValue={formatDateTimeWithSeconds(productionItem.beginDatetime)}/>

        <TextField className="form-control-large"
          variant="standard"
          slotProps={{ input: { readOnly: true, }}}
          label={getLanguage(systemContext.languageCode).end}
          defaultValue={formatDateTimeWithSeconds(productionItem.endDatetime)}/>

        <TextField className="form-control"
          variant="standard"
          slotProps={{ input: { readOnly: true, }}}
          label={systemContext.language.crew}
          defaultValue={productionItem.crew.name}/>

        <TextField className="form-control"
          variant="standard"
          slotProps={{
           input: {
             readOnly: true,
            endAdornment:<InputAdornment position="end">kWh</InputAdornment>
          }}}
          label="EAF kWh"
          defaultValue={heat.kwh}/>

        <TextField className="form-control"
          variant="standard"
         slotProps={{
           input: {
             readOnly: true,
            endAdornment:<InputAdornment position="end">kWh/Ton</InputAdornment>
          }}}
          label="kWh/Ton"
          defaultValue={heat.kwhTon ? heat.kwhTon.toFixed(2) : "---"}/>

        <TextField className="form-control"
          variant="standard"
           slotProps={{
             input: {
               readOnly: true,
            endAdornment:<InputAdornment position="end">%</InputAdornment>
          }}}
          label="Yield"
          defaultValue={(heat.yield * 100).toFixed(2)}/>

        <TextField className="form-control"
          variant="standard"
                   slotProps={{ input: { readOnly: true, }}}
          label={getLanguage(systemContext.languageCode).ladle}
          defaultValue={heat.ladleHistory ? heat.ladleHistory.ladle : "---"}/>

        <TextField className="form-control"
          variant="standard"
         slotProps={{
           input: {
             readOnly: true,
            endAdornment:<InputAdornment position="end">ton</InputAdornment>
          }}}
          label={getLanguage(systemContext.languageCode).weight}
          defaultValue={toTons(heat.weight).toFixed(2)}/>

        <TextField className="form-control"
          variant="standard"
         slotProps={{
           input: {
             readOnly: true,
            endAdornment:<InputAdornment position="end">°F</InputAdornment>
          }}}
          label={getLanguage(systemContext.languageCode).tapToTapTemperature}
          defaultValue={temperature.value}/>

        <TextField className="form-control"
          variant="standard"
          slotProps={{ input: { readOnly: true, }}}
          label={getLanguage(systemContext.languageCode).status}
          defaultValue={"OK"}/>
        {/*</Paper>*/}

      </div>
      <div className="flex-grow-0 text-center mt-2" style={{ width: 200, height: 160 }}>
        <PieChart pieConfig={pieConfig}/>
      </div>
    </div>
  );
};

export default GeneralPanel;
